
export interface Purchase {
  name: string
  location: string
  timeAgo: string
}

export const purchases: Purchase[] = [
  { name: 'Valentina', location: 'Buenos Aires, Argentina', timeAgo: 'Hace 2 minutos' },
  { name: 'Camila', location: 'Santiago, Chile', timeAgo: 'Hace 5 minutos' },
  { name: 'Sofía', location: 'Bogotá, Colombia', timeAgo: 'Hace 12 minutos' },
  { name: 'Mariana', location: 'Lima, Perú', timeAgo: 'Hace 15 minutos' },
  { name: 'Lucía', location: 'Montevideo, Uruguay', timeAgo: 'Hace 22 minutos' },
  { name: 'Florencia', location: 'Córdoba, Argentina', timeAgo: 'Hace 28 minutos' },
  { name: 'Daniela', location: 'Ciudad de México, México', timeAgo: 'Hace 35 minutos' },
  { name: 'Martina', location: 'Rosario, Argentina', timeAgo: 'Hace 42 minutos' },
  { name: 'Josefina', location: 'Medellín, Colombia', timeAgo: 'Hace 50 minutos' },
  { name: 'Paula', location: 'Guadalajara, México', timeAgo: 'Hace 1 hora' },
]
